import { Pencil, X, Save } from "lucide-react";

export const inputCls = "w-full px-3.5 py-2.5 rounded-xl bg-slate-950/70 border border-white/10 text-slate-100 text-sm focus:outline-none focus:border-cyan-400/60 transition-colors";
export const labelCls = "block text-sm font-semibold text-slate-300 uppercase tracking-wider mb-1.5";

export default function SectionCard({ title, desc, Icon, editing, onEdit, onCancel, onSave, saving, testid, children, hideActions }) {
  return (
    <div data-testid={testid} className="rounded-2xl border border-white/10 bg-slate-900/60 backdrop-blur-xl p-5 sm:p-7">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h3 className="text-lg font-semibold text-slate-100 flex items-center gap-2">
            {Icon && <Icon className="w-5 h-5 text-cyan-300" />} {title}
          </h3>
          {desc && <p className="text-sm text-slate-400 mt-1">{desc}</p>}
        </div>
        {!hideActions && (
          !editing ? (
            <button data-testid={`${testid}-edit-button`} onClick={onEdit}
              className="flex items-center gap-1.5 px-4 py-2 rounded-lg border border-white/10 text-slate-300 text-sm font-semibold hover:border-cyan-400/50 hover:text-cyan-300 transition-colors">
              <Pencil className="w-3.5 h-3.5" /> Düzenle
            </button>
          ) : (
            <div className="flex gap-2">
              <button data-testid={`${testid}-cancel-button`} onClick={onCancel}
                className="flex items-center gap-1.5 px-4 py-2 rounded-lg border border-white/10 text-slate-400 text-sm hover:text-slate-200 transition-colors">
                <X className="w-3.5 h-3.5" /> İptal
              </button>
              <button data-testid={`${testid}-save-button`} onClick={onSave} disabled={saving}
                className="flex items-center gap-1.5 px-4 py-2 rounded-lg bg-cyan-400 text-slate-950 text-sm font-bold hover:bg-cyan-300 transition-colors disabled:opacity-50">
                <Save className="w-3.5 h-3.5" /> {saving ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          )
        )}
      </div>
      <div className="mt-5">{children}</div>
    </div>
  );
}
